// Login-time Stream chat connection. The chat user update (name, picture, role, org team) runs first. If it fails,
// chat still connects with the user Stream already has, and the update is retried once in the background, so a slow
// Stream answer no longer shows "Error connecting to chat" (JAB, 2026-10-26). Only a failed connection is reported.
export const CHAT_USER_UPDATE_RETRY_MS = 5000;

export async function connectStreamChatUser({ updateUser, connectUser, retryDelayMs = CHAT_USER_UPDATE_RETRY_MS, schedule = setTimeout, log = console }) {
	let updateError = null;
	try {
		await updateUser();
	} catch (err) {
		updateError = err;
		log.warn("Unable to update the chat user; connecting with the existing one.", err);
	}

	let chatUser = null;
	try {
		chatUser = await connectUser();
	} catch (err) {
		log.log("!@!@!@", err && err.message, err);
		if (updateError) {
			throw updateError;
		}
		return null;
	}

	if (updateError && chatUser) {
		schedule(() => {
			Promise.resolve()
				.then(updateUser)
				.catch((err) => log.warn("Retrying the chat user update failed.", err));
		}, retryDelayMs);
	}
	return chatUser;
}
